// src/services/foSegmentService.js
import api from '../config/axios';

const BASE_PATH = '/fo-segments';

// ============= Query Operations =============

export const getAllFOSegments = async () => {
  const response = await api.get(BASE_PATH);
  return response.data;
};

export const getAllFOSegmentsPaged = async (page = 0, size = 10, sort = 'spanId,asc') => {
  const response = await api.get(`${BASE_PATH}/paged`, {
    params: { page, size, sort }
  });
  return response.data;
};

/**
 * Get FO segment by ID (with cache buster)
 * UPDATED: Added timestamp to prevent browser caching
 */
export const getFOSegmentById = async (id) => {
  // Add timestamp to prevent caching
  const timestamp = new Date().getTime();
  const response = await api.get(`${BASE_PATH}/${id}?_t=${timestamp}`);
  return response.data;
};

export const getFOSegmentBySpanId = async (spanId) => {
  const response = await api.get(`${BASE_PATH}/span/${spanId}`);
  return response.data;
};

export const searchFOSegments = async (filters = {}, page = 0, size = 10) => {
  const response = await api.get(`${BASE_PATH}/search`, {
    params: {
      spanId: filters.spanId || undefined,
      siteName: filters.siteName || undefined,
      mainArea: filters.mainArea || undefined,
      kota: filters.kota || undefined,
      ringType: filters.ringType || undefined,
      projectId: filters.projectId || undefined,
      status: filters.status || undefined,
      page,
      size
    }
  });
  return response.data;
};

/**
 * Get FO segments by project ID (with cache buster)
 */
export const getFOSegmentsByProject = async (projectId) => {
  const timestamp = new Date().getTime();
  const response = await api.get(`${BASE_PATH}/project/${projectId}?_t=${timestamp}`);
  return response.data;
};

// ============= Command Operations =============

export const createFOSegment = async (segmentData) => {
  const response = await api.post(BASE_PATH, segmentData);
  return response.data;
};

export const updateFOSegment = async (id, segmentData) => {
  const response = await api.put(`${BASE_PATH}/${id}`, segmentData);
  return response.data;
};

export const softDeleteFOSegment = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

// ============= Statistics Operations =============

export const getFOSegmentStatistics = async () => {
  const response = await api.get(`${BASE_PATH}/statistics`);
  return response.data;
};

// ============= Helper Functions =============

/**
 * Format distance from meters to km
 */
export const formatDistanceKm = (meters) => {
  if (!meters) return '-';
  return `${(meters / 1000).toFixed(2)} km`;
};

/**
 * Get ring type badge class
 */
export const getRingTypeBadgeClass = (ringType) => {
  const types = {
    'Insert': 'bg-green-100 text-green-800',
    'Add Span': 'bg-blue-100 text-blue-800',
    'Star': 'bg-purple-100 text-purple-800'
  };
  return types[ringType] || 'bg-gray-100 text-gray-800';
};

/**
 * Get status display name
 */
export const getStatusDisplayName = (status) => {
  const statuses = {
    'STARTED': 'Started',
    'IN_PROGRESS': 'In Progress',
    'ON_HOLD': 'On Hold',
    'COMPLETED': 'Completed',
    'CLOSED': 'Closed'
  };
  return statuses[status] || status;
};

/**
 * Get status badge class
 */
export const getStatusBadgeClass = (status) => {
  const statuses = {
    'STARTED': 'bg-gray-100 text-gray-800',
    'IN_PROGRESS': 'bg-blue-100 text-blue-800',
    'ON_HOLD': 'bg-yellow-100 text-yellow-800',
    'COMPLETED': 'bg-green-100 text-green-800',
    'CLOSED': 'bg-red-100 text-red-800'
  };
  return statuses[status] || 'bg-gray-100 text-gray-800';
};

export default {
  getAllFOSegments,
  getAllFOSegmentsPaged,
  getFOSegmentById,
  getFOSegmentBySpanId,
  searchFOSegments,
  getFOSegmentsByProject,
  createFOSegment,
  updateFOSegment,
  softDeleteFOSegment,
  getFOSegmentStatistics,
  formatDistanceKm,
  getRingTypeBadgeClass,
  getStatusDisplayName,
  getStatusBadgeClass
};